import { create } from 'zustand'
import type {
  Project,
  Session,
} from '@/features/session/domain/models/session.ts'

interface AppStore {
  org?: string | undefined
  project?: Project
  session?: Session
  team?: string | undefined
  setOrg: (orgId: string | undefined) => void
  setProject: (project: Project) => void
  setSession: (session: Session) => void
  setTeam: (teamId: string | undefined) => void
}

export const useAppStore = create<AppStore>((set) => ({
  setOrg: (orgId: string | undefined) => {
    set(() => ({ org: orgId }))
  },
  setProject: (project: Project) => {
    set(() => ({ project }))
  },
  setSession: (session: Session) => {
    set(() => ({ session }))
  },
  setTeam: (team: string | undefined) => {
    set(() => ({ team }))
  },
}))
